// @flow
import React from 'react';
import i18n from 'i18n-js';

import moment from 'moment';
import styles from './routeCardStop.css';
import { transformTime, getMeridian } from '../../lib/time';
import type { ROUTE_STOP_TYPE } from '../../types/routes';

type RouteCardStopPropTypes = {
  name: string,
  // isNext?: boolean,
  // isLast?: boolean,
  // isDestiny?: boolean,
  eta_distance: Object,
  firstStop: ROUTE_STOP_TYPE,
};

const RouteCardStop = ({
  name = '',
  // isNext = false,
  // isLast = false,
  // isDestiny = false,
  eta_distance = {},
  firstStop,
  ..._rest
}: RouteCardStopPropTypes) => {
  if ( eta_distance && eta_distance !== null) {
    const { eta, distance, is_eta, time } = eta_distance;
    let sum = '';
    if (!is_eta && firstStop.eta_distance) {
      sum = moment.utc(firstStop.eta_distance.time).local().add(time, 'seconds');
    }
    return (
      <div className={styles.routeCardStop}>
        <div className={styles.nameContainer}>
          <div className={styles.label}>
            {i18n.t('common.goingTo')}
          </div>
          <div className={styles.name}>
            { name }
          </div>
        </div>
        {/* <div className={styles.cardSeparator} /> */}
        {/* <div className={ styles.type }>
        {
          `
            ${ isNext ? 'Siguiente parada' : '' }
            ${ isLast ? 'Ultima parada' : '' }
            ${ isDestiny ? 'Destino' : '' }
          `
        }
        </div> */}
        {/* <div className={styles.etaContainer}>
          <div className={styles.etaLabel}>
            { 'eta' }
          </div>
          <div className={styles.eta}>
            { is_eta ? moment.utc(time).local().format('hh:mm A').toString() : sum && sum.format('hh:mm A').toString() }
          </div>
        </div> */}

        {/* <div className={styles.etaContainer}> */}
        {/* <div className={styles.etaLabel}> */}
        {/* { 'Distancia' } */}
        {/* </div> */}
        {/* <div className={styles.eta}> */}
        {/* { `${distance} KM` } */}
        {/* </div> */}
        {/* </div> */}
      </div>
    );
  }
  return (
    <div className={styles.routeCardStop}>
      <div className={styles.nameContainer}>
        <div className={styles.label}>
          {i18n.t('common.goingTo')}
        </div>
        <div className={styles.name}>
          { name }
        </div>
      </div>
    </div>
  );
};

export default RouteCardStop;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteCardStop/index.jsx